import React, { useEffect, useState } from 'react'
import { Col, Empty, Row, Timeline } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import { selectListEvent, selectLogProductsList } from 'Store/product/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { LogData, RequestProductReq } from 'Store/product/types'
import { getLogProductsAPI } from 'Store/product/api'
import { LoadingView } from 'Components/modal'
import { formatDateTime, getProductRequestAction, getProductRequestStatus } from 'helpers/format'
import Label from 'Components/text/Label'
import { MyTheme } from 'Components/common/Theme'
import { ProductRequestStatus } from 'helpers/constanst'
import LogHistoryDrawer from './LogHistoryDrawer'
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import { selectIsPackageC } from 'Store/pos/selector'

type Props = {
  isShow: boolean
  onClose: () => void
  productID: number
} & ReduxProps

const RequestHistoryDrawer = (props: Props) => {
  const { isShow, onClose, event, list, currentUser, productID, isPackageC } = props
  const [compareDrawer, setCompareDrawer] = useState(false)
  const [selectedLog, setSelectedLog] = useState(undefined as LogData | undefined)
  console.log('list', list)

  const dispatch = useDispatch()

  const onGetDataList = (): void => {
    const req: RequestProductReq = {
      merchant_id: currentUser?.activeMerchant?.id || 0,
      product_id: productID,
      all: true,
    }
    dispatch(getLogProductsAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    if (isShow) {
      onGetDataList()
    }
  }, [isShow, productID])

  const onClickSeeDetail = (data: LogData) => {
    setSelectedLog(data)
    setCompareDrawer(true)
  }

  const LogCompare = (
    <LogHistoryDrawer
      isShow={compareDrawer}
      onClose={() => setCompareDrawer(false)}
      data={selectedLog}
      isPackageC={isPackageC}
    />
  )

  const getTimeLines = () => {
    let timeline = [] as any
    timeline =
      list &&
      list.data &&
      list.data.map((item: LogData, index: number) => {
        const isUpdate = item.request_action === 'update' || item.request_action === 'update-price'
        const isCreate = item.request_action === 'create'
        const type = getProductRequestAction(item.request_action)
        const status = getProductRequestStatus(item.status)
        const isPending = status.status === ProductRequestStatus.PENDING
        let icon = <StartDot style={{ fontSize: '16px' }} />
        if (item.request_action === 'approved') {
          icon = <CheckCircleFilled style={{ fontSize: '16px' }} />
        }
        if (item.request_action === 'rejected') {
          icon = <CloseCircleFilled style={{ fontSize: '16px' }} />
        }
        return (
          <Timeline.Item key={index} color={type.color} dot={icon}>
            {type.text}
            <LabelStyle color={status.color}> {isPending ? `(${status.text})` : ''}</LabelStyle>
            <br />
            <LabelStyle>หมายเหตุ : {item.update_remark || '-'}</LabelStyle>
            <br />
            <LabelStyle>วัน/เวลาทำรายการ : {formatDateTime(item.created_at)}</LabelStyle>
            <br />
            {(isUpdate || isCreate) && (
              <LabelStyle>ผู้ทำรายการ : {item?.request_action_by || '-'}</LabelStyle>
            )}
            {isUpdate && (
              <LinkStyle onClick={() => onClickSeeDetail(item)}>
                <br />
                ดูรายละเอียดการแก้ไข
              </LinkStyle>
            )}
          </Timeline.Item>
        )
      })
    timeline.push(
      <Timeline.Item key="start" dot={<StartDot />}>
        <LabelStyle>เริ่มต้น</LabelStyle>
      </Timeline.Item>,
    )
    return timeline
  }

  return (
    <DetailDrawer
      title={'ประวัติการแก้ไข'}
      width={'70%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      <LoadingView isShow={event.IsLoading} />
      <Row>
        <Col span={24}>
          {list && list.data && list.data.length > 0 ? (
            <Timeline>{getTimeLines()}</Timeline>
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Col>
      </Row>
      {LogCompare}
    </DetailDrawer>
  )
}

const StartDot = styled.div`
  width: 10px;
  height: 10px;
  border: 2px solid ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  border-radius: 100px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const LabelStyle: any = styled(Label)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const LinkStyle: any = styled(Label)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectListEvent(state),
    list: selectLogProductsList(state),
    isPackageC: selectIsPackageC(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(RequestHistoryDrawer)
